import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconAlignHorizontalLeft';
/** Renders an SVG icon. */
const SvgAlignHorizontalLeft = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M26 25a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2zm0-6v4H10v-4zm-9-4a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2zm0-6v4h-7V9zM5 28a1 1 0 0 0 1-1V5a1 1 0 0 0-2 0v22a1 1 0 0 0 1 1"
        clipRule="evenodd"
      />
    </svg>
  );
};
SvgAlignHorizontalLeft.displayName = displayName;
export default SvgAlignHorizontalLeft;
